// Importing necessary action type constants
import * as ACTION from '../../Redux.constants';

/**
 * MenuListReducer
 * A reducer function to manage the state of menu items.
 * 
 * @param {Array} state - Represents the current state of the menu list.
 * @param {Object} action - Represents the dispatched action.
 * @returns {Array} - Returns the new state of the menu list based on the action.
 */
export function MenuListReducer(state = [], action) {
  switch (action.type) {
    // When the level is set, the entire menu list is replaced with the new list.
    case ACTION.SET_LEVEL:
      return action.payload.MENU_LIST;

    // When a new chapter is set, the state of menu items (current, visited) is updated.
    case ACTION.SET_CHAPTER:
      return updateNewCurrentChapterInMenuList(state, action.payload);

    // For any other action, simply return the current state.
    default:
      return state;
  }
}

/**
 * updateNewCurrentChapterInMenuList
 * Helper function to update the state of menu items (current, visited) based on the new chapter.
 * 
 * @param {Array} menuList - Represents the current menu list.
 * @param {string|number} newCurrentChapter - Represents the value of the new chapter to set as current.
 * @returns {Array} - Returns the updated menu list.
 */
function updateNewCurrentChapterInMenuList(menuList, newCurrentChapter) {
  return menuList.map((menu) => {
    // If the menu item is currently set as 'current', mark it as 'visited'.
    if (menu.current) {
      menu = {...menu, visited: true};
    }

    // If the menu item's value matches the new chapter, set it as 'current' and unset 'visited'.
    if (menu.value === newCurrentChapter) {
      menu = {...menu, current: true, visited: false};
    } else {
      menu = {...menu, current: false};
    }

    return menu;
  });
}
